import AnimationUtil from "../v2/utils/AnimationUtil";

const webase = {
    utils: {
        animation: new AnimationUtil()
    }
}

window.webase = webase